import { OperatorAuthType, OperatorGroup } from "./constant";

/**
 * 権限によるチェーンリストを表示可能かチェックする
 * -運用管理者
 * -運用管理者(兼本部管理者)
 * @param authType 権限
 * @return true:表示可、false:表示不可
 */
export function checkChainListDisplay(authType: string): boolean {
  //表示可能な権限(運用管理者、コールセンター)
  const displayAuthType = [
    OperatorAuthType.operator_admin,
    OperatorAuthType.operator_shop_admin,
  ];

  if (displayAuthType.indexOf(authType) >= 0) {
    return true;
  } else {
    return false;
  }
}

/**
 * 権限による店舗リストを表示可能かチェックする
 * -店舗
 * @param group 所属グループ
 * @return true:表示可、false:表示不可
 */
export function checkShopListDisplay(group: string): boolean {
  //表示可能な所属グループ(店舗、本部、その他)
  const displayGroupType = [OperatorGroup.shop];

  if (displayGroupType.indexOf(group) >= 0) {
    return true;
  } else {
    return false;
  }
}

/**
 * 個人情報(ダウンロード・表示)の可・不可の編集が可能かチェックする
 * (単純に権限のみチェック)
 * @param authType 権限
 * @return true:編集不可、false:編集可
 */
export function checkPersonalDisabled(authType: string): boolean {
  //編集可能な権限(店舗)
  const displayAuthType = [OperatorAuthType.shop];

  if (displayAuthType.indexOf(authType) < 0) {
    return true;
  } else {
    return false;
  }
}

/**
 * 所属グループが店舗であるか判定する
 * @param group 所属グループ
 * @return true:店舗、false:店舗以外
 */
export function isOperatorGroupShop(group: string): boolean {
  if (group === OperatorGroup.shop) {
    return true;
  } else {
    return false;
  }
}

/**
 * 所属グループが本部であるか判定する
 * @param group 所属グループ
 * @return true:本部、false:本部以外
 */
export function isOperatorGroupAdmin(group: string): boolean {
  if (group === OperatorGroup.shop_admin) {
    return true;
  } else {
    return false;
  }
}

/**
 * 所属グループがその他であるか判定する
 * @param group 所属グループ
 * @return true:その他、false:その他以外
 */
export function isOperatorGroupOther(group: string): boolean {
  if (group === OperatorGroup.other) {
    return true;
  } else {
    return false;
  }
}
